$(document).ready(function(){
	$('.TruyenThong .album-img').lightGallery({
		thumbnail:true,
		animateThumb: true,
		showThumbByDefault: true
	}); 
})
